import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Modal } from "antd";
import { brand, neutral, semantic, spacing } from "../../theme/tokens";

/**
 * Quy ước icon + xác nhận cho hành động trên màn danh sách.
 *
 * Lý do có file này: audit toàn bộ 39 màn list thấy cùng một hành động mà mỗi màn
 * một kiểu — "xem chi tiết" dùng 3 icon khác nhau (Eye 36 / InfoCircle 21 /
 * FileText 14), "thêm mới" 2 icon, xóa thì 30 màn dùng Popconfirm còn 5 màn dùng
 * Modal.confirm, và màu thì hard-code 3 mã đỏ khác nhau cho cùng ý "nguy hiểm".
 *
 * Chốt:
 *  - Xem chi tiết -> EyeOutlined (đang phổ biến nhất). `InfoCircleOutlined` để
 *    dành riêng cho tooltip giải thích, KHÔNG dùng làm nút xem.
 *  - Thêm mới -> PlusOutlined, nhãn luôn là "Thêm mới".
 *  - Xóa -> DeleteOutlined + `Modal.confirm`, KHÔNG dùng Popconfirm: xóa là hành
 *    động không hoàn tác, Popconfirm nằm sát nút nên quá dễ bấm nhầm hai lần liên tiếp.
 *  - Màu lấy từ `theme/tokens`, không viết mã hex tại chỗ.
 */

export const ACTION_ICON = {
  view: <EyeOutlined />,
  edit: <EditOutlined />,
  delete: <DeleteOutlined />,
  add: <PlusOutlined />,
};

export const ACTION_COLOR = {
  view: neutral[600],
  edit: brand.accent,
  delete: semantic.danger,
};

/**
 * Hộp thoại xác nhận cho hành động phá hủy.
 *
 * @param {{ title: string, content?: React.ReactNode, okText?: string, onOk: Function }} opts
 */
export function confirmDanger({ title, content, okText = "Xóa", onOk }) {
  Modal.confirm({
    title,
    icon: <ExclamationCircleOutlined style={{ color: semantic.danger }} />,
    content,
    okText,
    okButtonProps: { danger: true },
    cancelText: "Hủy",
    onOk,
  });
}

/**
 * Xác nhận xóa một bản ghi — dùng chung để câu chữ không mỗi màn một kiểu.
 *
 * @param {string} name    tên bản ghi hiện trong câu hỏi
 * @param {Function} onOk
 * @param {string} [note]  câu giải thích thêm (vd: xóa mềm, giữ lịch sử)
 */
export function confirmDelete(name, onOk, note) {
  confirmDanger({
    title: "Xác nhận xóa",
    content: (
      <div>
        <div>
          Bạn có chắc chắn muốn xóa <b>{name}</b>?
        </div>
        {note && (
          <div style={{ marginTop: spacing[2], color: neutral[500] }}>{note}</div>
        )}
      </div>
    ),
    onOk,
  });
}
